import Vue,{h} from 'vue'
import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import {Modal} from 'ant-design-vue'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router, { resetRouter } from '../router'
import { jd_getAccessCodeUrl } from '@/api/thirdPartyAPI.js'


// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120000 ,// 请求超时时间
  withCredentials: true//允许跨域
})
let errorFlag = false;
// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = storage.get(ACCESS_TOKEN);
    if (error.response.status === 403) {
      notification.error({
        message: data.msg,
        description: ''
      })
      return false;
      //router.push('/user/login');
    }
    if (error.response.status === 404) {
      notification.error({
        message: "请求资源不存在",
        description: ''
      })
      return false;
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '未授权',
        description: '未授权，人证失败.'
      })
      router.push('/user/login');
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
    if (error.response.status === 500) {
      notification.error({
        message: '服务器内部错误',
        description: ''
      })
      return false;
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ACCESS_TOKEN] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if(response.data.code && response.data.code !== 1){
    if(response.data.code === -2005){//京东授权已过期或不存在，请重新授权
      Modal.confirm({
        content: () => { return (
            <div>
              <span>
                {response.data.msg}
              </span>
            </div>
          )},
        centered: true,
        okText: '去授权',
        cancelText:'取消',
        onOk: async () => {
          let accessResult = await jd_getAccessCodeUrl();
          window.open(accessResult.data);
        },
        onCancel: () => {},
      })
    }else if(response.data.code === -10003){//重复授权
      Modal.info({
        content: <span> {response.data.msg} </span>,
        centered: true,
        footer: null,
        okText: "确认"
      });

    }else{
      notification.error({
        message: response.data.msg,
        description: ''
      })
    }
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
